import { type FC, type MouseEventHandler, type ReactNode } from 'react';
import { Link } from '../Link/index.tsx';
import classnames from 'classnames';
import styles from './styles.scss';
import dibsCss from 'dibs-css';

type Props = {
    children: ReactNode;
    onClick: MouseEventHandler;
    isActive?: boolean;
    dataTn?: string;
};

export const Chip: FC<Props> = ({ children, onClick, isActive, dataTn }) => {
    return (
        <Link
            onClick={onClick}
            underline="none"
            dataTn={dataTn}
            className={classnames(
                styles.chip,
                dibsCss.textBodySmallNormal,
                dibsCss.whitespaceNowrap,
                dibsCss.roundedFull,
                {
                    [styles.active]: isActive,
                }
            )}
        >
            {children}
        </Link>
    );
};
